import type { LoadableComponent } from '@loadable/component';
import type { ComponentType } from 'react';
import type { LayoutProps } from './LayoutProps.type';

const PublicRoute = (props: {
    component: ComponentType | LoadableComponent<object>;
    layout: ComponentType<LayoutProps>;
    name?: string;
}) => {
    const { component: Component, layout: Layout, name: Name } = props;
    return (
        <Layout name={Name}>
            <Component />
        </Layout>
    );
};

export default PublicRoute;
